import Modal from './modal.component'

export default Modal
